// @ts-nocheck
import React, { useState } from "react"
import styles from "./styles"

import { FormControl, OutlinedInput } from '@mui/material'
import { InputLabel, FormHelperText } from '@mui/material'

export default function InputEmail(props) {
  const { label, value, setValue, onChange, onBlur, sx,readOnly,disabled,errorText } = props
  const [helperText, setHelperText] = useState(() => "")

  function handleChange(event) {
    const value = event.target.value

    setValue(value)
    if (onChange) onChange({ value })
  }

  function handleBlur(event) {
    const value = event.target.value

    const error = validateEmail(value)
    if (onBlur) onBlur({ value, error })
  }

  function validateEmail(value) {
    const emailRegex = /^[\w-+\.]+@([\w-]+\.)+[\w-]+$/g

    let error = ""
    if (value && !emailRegex.test(value)) error = "Please enter a valid email address"

    setHelperText(error)
    return error
  }

  return (
    <FormControl variant="outlined" sx={{ ...styles.container, ...sx }}>
      <InputLabel htmlFor={`input-email-${label}`} sx={styles.label}>{label}</InputLabel>

      <OutlinedInput
        id={`input-email-${label}`}
        label={label}
        type="text"
        value={value}
        readOnly={readOnly}
        disabled={disabled}
        onChange={handleChange}
        inputProps={{ onBlur: handleBlur }}
        sx={styles.input(value,errorText)}
      />

      {/* {Boolean(errorText) && <FormHelperText sx={styles.errorText}>{errorText}</FormHelperText>} */}
			{(Boolean(helperText) || Boolean(errorText)) && <FormHelperText sx={styles.helperText}>{helperText || errorText}</FormHelperText>}
    </FormControl>
  )
}